import { writable } from 'svelte/store';

export const viewport = writable(getViewport());

function getViewport() {
  const w = window.innerWidth;
  if (w < 960) return 'sm';
  if (w >= 960 && w < 1440) return 'md';
  return 'lg';
}

export function init() {
  window.addEventListener('resize', () => {
    viewport.set(getViewport());
  });
}
